import { render, staticRenderFns } from "./home_m.vue?vue&type=template&id=d5a39366&scoped=true&"
import script from "./home_m.vue?vue&type=script&lang=js&"
export * from "./home_m.vue?vue&type=script&lang=js&"
import style0 from "./home_m.vue?vue&type=style&index=0&id=d5a39366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a39366",
  null
  
)

export default component.exports